<div>
  <div class="container mb-5" style="border: 2px solid black" id="print-section">

    <!-- HEADER -->
    <div class="row">
      <div class="col-3">
        <img style="margin-top: 8%" width="90%" src="../../../assets/img/brand/red.png" />
      </div>

      <div class="col-7 text-center" style="padding-top: 30px;">
        <span style="font-size: 30px; font-weight: bold">हिंदुस्थान प्रकाशन संस्था</span>
        <span style="font-size: 14px">(Reg.No.-BOM-3/1961(GBBSD))</span>
        <hr />

        <div class="row text-left">
          <div class="col-6">
            <b>प्रशासकीय कार्यालय :</b><br>
            116-119, शिल्पीन सेंटर, वडाळा, मुंबई - 400031<br>
            <b>दूरध्वनी :</b> 9967570531
          </div>

          <div class="col-6" style="border-left: 2px solid black;">
            <b>मुख्य कार्यालय :</b><br>
            प्रभादेवी, मुंबई - 400025<br>
            <b>दूरध्वनी :</b> 24221440
          </div>
        </div>
      </div>

      <div class="col-2 text-center" style="border-left:2px solid black; display:flex; align-items:center;">
        <b>अंक/ग्रंथ विक्री जमा पावती</b>
      </div>
    </div>

    <!-- CUSTOMER -->
    <div class="row" style="border-top:2px solid black; padding:15px;">
      <div class="col-6">
        <b>Granth Seller Name :</b> {{sellerData?.subscribersName}}<br>
        <b>Address :</b> {{sellerData?.address}} {{sellerData?.taluka}} {{sellerData?.district}}<br>
        <b>Mobile :</b> {{sellerData?.mobile}}
      </div>

      <div class="col-6" style="border-left:2px solid black;">
        <b>Receipt No :</b> {{receiptNo}}<br>
        <b>Date :</b> {{today}}<br>

        <b>Amount :</b> {{receivedamt}} /-<br>
        <b>In Words :</b> {{totalInWords}}
      </div>
    </div>

    <!-- BOOK LIST -->
    <div class="row" style="border-top:2px solid black; padding:15px;">
      <div class="col-12">

        <b>Order No:</b> {{orderno}}<br>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="row" style="margin-top:80px;">
      <div class="col-6">
        <b>(धनादेश वटल्यावरच पावती अधिकृत होईल)</b>
      </div>
      <div class="col-6 text-right">
        <b>व्यवस्थापक / लेखापाल</b>
      </div>
    </div>
  </div>

  <!-- BUTTONS -->
  <button (click)="addBookSellerEntryPackage()" mat-raised-button color="primary">Save</button>
  <button (click)="print()" mat-raised-button color="accent">Print</button>
</div>